let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("7tUK8")).then(() => parcelRequire('aatrQ'));